module.exports = __webpack_public_path__ + "img/badge.3ddbeabd.svg";